import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomGenericLinkModule } from '../../../shared/components/custom-generic-link/custom-generic-link.module';
import { CustomNavigationUiComponent } from './custom-navigation-ui/custom-navigation-ui.component';
import { CustomNavigationComponent } from './custom-navigation/custom-navigation.component';
import { CustomIconsModule } from '../../../../../custom/icons/custom-icons.module';

@NgModule({
  declarations: [CustomNavigationUiComponent, CustomNavigationComponent],
  exports: [CustomNavigationUiComponent, CustomNavigationComponent],
  imports: [
    CommonModule,
    RouterModule,
    CustomIconsModule,
    CustomGenericLinkModule,
    I18nModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        NavigationComponent: {
          component: CustomNavigationComponent,
        },
      },
    }),
  ],
})
export class CustomNavigationModule {}
